/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.user.job.profiles.rpc.AppUserPersonas
 */
import * as References from './AppUserPersonas';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.user.job.profiles.rpc.AppUserPersonas#getUserPersonas
 */
export const GET_USER_PERSONAS_QUERY_FIELD_NAME = 'com_hubspot_user_job_profiles_rpc_AppUserPersonas_getUserPersonas';
export const GET_USER_PERSONAS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_USER_PERSONAS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getUserPersonasRpc, {
      timeout: ctx.timeout
    });
  }
});